<template>
  <div class="ts-w-full ts-mt-3">
    <panel :title="$t('studentEnrollment.enrollmentList')">
      <div class="overflow-auto">
        <table class="table table-hover ui-table ts-table mt-2">
          <thead>
            <tr>
              <th class="ts-whitespace-no-wrap">
                {{ $t('studentEnrollment.cardNumber') }}
              </th>
              <th class="ts-whitespace-no-wrap">
                {{ $t('studentEnrollment.studentName') }}
              </th>
              <th class="ts-whitespace-no-wrap">
                {{ $t('studentEnrollment.sex') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width:7%">
                {{ $t('studentEnrollment.isMain') }}
              </th>
              <th class="ts-whitespace-no-wrap text-center" style="width:7%">
                {{ $t('studentEnrollment.swap') }}
              </th>
              <th class="ts-whitespace-no-wrap text-center" style="width:15%">
                {{ $t('studentEnrollment.session') }}
              </th>
              <th class="ts-whitespace-no-wrap text-center" style="width:15%">
                {{ $t('studentEnrollment.studyTime') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width:3%">
                {{ $t('actions') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list, index) in model.student_id_list" :key="index">
              <td class="ts-whitespace-no-wrap">
                {{ studentFilter(list).card_number }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ studentFilter(list).full_name_en }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ studentFilter(list).gender }}
              </td>
              <td style="padding-top: 5px;">
                <div class="checkbox checkbox-css">
                  <input
                    type="checkbox"
                    id="is_main"
                    v-model="list.is_main_class"
                  />
                  <label for="is_main"></label>
                </div>
              </td>
              <td class="text-center">
                <select v-model.number="list.swap_type_id" class="none-border">
                  <option value="0">{{ $t('studentEnrollment.fixed') }}</option>
                  <option value="1">{{ $t('studentEnrollment.odd') }}</option>
                  <option value="2">{{ $t('studentEnrollment.even') }}</option>
                </select>
              </td>
              <td class="text-center">
                <a-select
                  v-model="list.session"
                  mode="multiple"
									:maxTagCount="1"
									class="ts-w-full"
                  :options="sessions"
                ></a-select>
              </td>
              <td class="text-center">
                <a-select
                  v-model="list.ac_st_id"
									class="ts-w-full"
                  :allowClear="true"
                  :options="study_times"
                  :class="{
                            'is-invalid': errors.has(
                              'student_id_list.' + index + '.ac_st_id'
                            )
                          }"
                ></a-select>
                <div
                  class="validate"
                  v-if="errors.has('student_id_list.' + index + '.ac_st_id')"
                >
                  {{
                    errors.first('student_id_list.' + index + '.ac_st_id')
                  }}
                </div>
              </td>
              <td class="text-center">
                <a href="#" class="text-danger" @click="removeStudent(list)"
                  ><i class="fa fa-trash"></i
                ></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </panel>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'studentListEnrollment',
  props: ['value', 'enroll', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      studentEnrollments: [],
			sessions: [],
			study_times: []
    }
  },
  created() {
    this.model = this.value
		this.fetchSession()
		this.fetchStudyTime()
  },
  methods: {
		...mapActions('studentEnrollment', ['getSession', 'getStudyTime']),
		fetchSession(){
			this.$emit('loading', true)
			this.getSession()
				.then(response => {
						this.sessions = response.data.map(el => ({
							value: el.session_id,
							label: el.session_name
						}))
				})
				.finally(() => {
					this.$emit('loading', false)
				})
		},
		fetchStudyTime(){
			this.$emit('loading', true)
			this.getStudyTime()
				.then(response => {
						this.study_times = response.data.map(el => ({
							value: el.ac_st_id,
							label: el.study_time
						}))
				})
				.finally(() => {
					this.$emit('loading', false)
				})
		},
    studentFilter(student) {
      return this.enroll.filter(
        s => s.student_id == student.student_id
      )[0]
    },
    removeStudent(student) {
      this.model.student_id_list.splice(
        this.model.student_id_list.indexOf(student),
        1
      )
			this.$emit('removeStudent', student)
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
#enroll {
  height: 70vh;
}

#student-table-container {
  height: 40vh;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}
::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}

#student-table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}

#student-table > tbody > tr > td {
  cursor: pointer;
}

.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
.none-border {
  border: none
}
</style>
